import React from "react";

interface IProps {
  width?: string;
  height?: string;
  fill?: string;
  className?: string;
  stroke?: string;
  strokeWidth?: string;
  dataFlip?: string;
}

const IconLeftArrowHead = ({
  width = "24",
  height = "24",
  fill = "#797979",
  className = "",
  stroke = "",
  strokeWidth = "",
  dataFlip = "true",
}: IProps) => {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className ? className : null}
      width={width}
      height={height}
      data-name="IconLeftArrowHead"
      data-flip={dataFlip}
    >
      <path
        fill={fill}
        stroke={stroke}
        strokeWidth={strokeWidth}
        d="M21.547 9.88l-6.107 6.12 6.107 6.12-1.88 1.88-8-8 8-8z"
      />
    </svg>
  );
};

export default IconLeftArrowHead;
